var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdditionalInfoArchiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 35,
    height: 35,
    rx: 3.5,
    stroke: "#28519E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4344 13.8453L24.1844 11.3453C24.1324 11.2415 24.0526 11.1542 23.9538 11.0932C23.855 11.0322 23.7411 10.9999 23.625 11H12.375C12.2589 10.9999 12.145 11.0322 12.0462 11.0932C11.9474 11.1542 11.8676 11.2415 11.8156 11.3453L10.5656 13.8453C10.5225 13.9323 10.5001 14.028 10.5 14.125V24.75C10.5 25.0815 10.6317 25.3995 10.8661 25.6339C11.1005 25.8683 11.4185 26 11.75 26H24.25C24.5815 26 24.8995 25.8683 25.1339 25.6339C25.3683 25.3995 25.5 25.0815 25.5 24.75V14.125C25.4999 14.028 25.4775 13.9323 25.4344 13.8453ZM20.9422 20.8172L18.4422 23.3172C18.3841 23.3753 18.3152 23.4214 18.2393 23.4529C18.1635 23.4843 18.0821 23.5005 18 23.5005C17.9179 23.5005 17.8365 23.4843 17.7607 23.4529C17.6848 23.4214 17.6159 23.3753 17.5578 23.3172L15.0578 20.8172C14.9405 20.6999 14.8747 20.5409 14.8747 20.375C14.8747 20.2091 14.9405 20.0501 15.0578 19.9328C15.1751 19.8155 15.3341 19.7497 15.5 19.7497C15.6659 19.7497 15.8249 19.8155 15.9422 19.9328L17.375 21.3664V16.625C17.375 16.4592 17.4408 16.3003 17.5581 16.1831C17.6753 16.0658 17.8342 16 18 16C18.1658 16 18.3247 16.0658 18.4419 16.1831C18.5592 16.3003 18.625 16.4592 18.625 16.625V21.3664L20.0578 19.9328C20.1751 19.8155 20.3341 19.7497 20.5 19.7497C20.6659 19.7497 20.8249 19.8155 20.9422 19.9328C21.0595 20.0501 21.1253 20.2091 21.1253 20.375C21.1253 20.5409 21.0595 20.6999 20.9422 20.8172ZM12.1359 13.5L12.7609 12.25H23.2391L23.8641 13.5H12.1359Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalInfoArchiveIcon);
export default __webpack_public_path__ + "static/media/AdditionalInfoArchiveIcon.ea8792792f41a52ef4340fa9c30f2b42.svg";
export { ForwardRef as ReactComponent };